'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.changeCaptchaRequired = changeCaptchaRequired;
exports.captchaRequired = captchaRequired;
exports.editCaptchaToken = editCaptchaToken;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CAPTCHA_TOKEN = 'redux/auth/CAPTCHA_TOKEN';
var CAPTCHA_REQUIRED = 'redux/captcha/CAPTCHA_REQUIRED';
var CAPTCHA_REQUIRED_SUCCESS = 'redux/captcha/CAPTCHA_REQUIRED_SUCCESS';
var CAPTCHA_REQUIRED_FAIL = 'redux/captcha/CAPTCHA_REQUIRED_FAIL';
var CHANGE_CAPTCHA_REQUIRED = 'redux/captcha/CHANGE_CAPTCHA_REQUIRED';

var initialState = {
  needCaptcha: false,
  captchaToken: ''
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CAPTCHA_TOKEN:
      return (0, _extends3.default)({}, state, {
        captchaToken: action.value
      });
    case CAPTCHA_REQUIRED:
      return (0, _extends3.default)({}, state);
    case CAPTCHA_REQUIRED_SUCCESS:
      return (0, _extends3.default)({}, state, {
        needCaptcha: state.needCaptcha ? state.needCaptcha : action.result.data === 'true'
      });
    case CAPTCHA_REQUIRED_FAIL:
      return (0, _extends3.default)({}, state, {
        needCaptcha: false
      });
    case CHANGE_CAPTCHA_REQUIRED:
      return (0, _extends3.default)({}, state, {
        needCaptcha: action.value
      });
    default:
      return state;
  }
}

function changeCaptchaRequired(value) {
  return { type: CHANGE_CAPTCHA_REQUIRED, value: value };
}

function captchaRequired(captchaTypeObject) {
  return function (dispatch, getState) {
    return dispatch({
      types: [CAPTCHA_REQUIRED, CAPTCHA_REQUIRED_SUCCESS, CAPTCHA_REQUIRED_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          return loginClient.user.captchaRequired({
            clientId: getState().auth.clientId,
            classPath: captchaTypeObject.classPath,
            methodPath: captchaTypeObject.methodPath,
            requestMethod: captchaTypeObject.method
          }, { responseContentType: 'application/json' }).then(function (result) {
            return result;
          });
        });
      }
    });
  };
}

function editCaptchaToken(value) {
  return { type: CAPTCHA_TOKEN, value: value };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/captcha.js
// module id = 816
// module chunks = 0